// extracted by mini-css-extract-plugin
export default {"editMenu":"EditMenu_editMenu__XQhn1","listItem":"EditMenu_listItem__Psdif","disabled":"EditMenu_disabled__xqxcS","link":"EditMenu_link__3FxKd"};